import { useEffect, useState } from "react";

import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Switch } from "@/components/ui/switch";

import { dataBR, reais } from "../api";

const OPCOES = [1, 2, 3, 4, 6, 8, 12];
const SEMANA_MS = 7 * 86400000;

/** Estender, encurtar, ou ligar e desligar a renovação semanal de uma campanha. */
export default function DialogoPeriodo({ campanha, aoFechar, aoSalvar }) {
  const atuais = campanha?.semanas || 1;
  const [semanas, setSemanas] = useState(atuais);
  const [continua, setContinua] = useState(false);
  const [salvando, setSalvando] = useState(false);
  useEffect(() => { if (campanha) { setSemanas(campanha.semanas || 1); setContinua(!!campanha.continua); } }, [campanha]);
  if (!campanha) return null;

  const opcoes = [...new Set([...OPCOES, atuais])].sort((x, y) => x - y);
  const fimNovo = campanha.fim ? new Date(new Date(campanha.fim).getTime() + (semanas - atuais) * SEMANA_MS) : null;
  const mudou = continua !== !!campanha.continua || (!continua && semanas !== atuais);
  const diferenca = (semanas - atuais) * (campanha.orcamento_semanal_centavos || 0);
  const salvar = async () => {
    setSalvando(true);
    const ok = await aoSalvar({ continua, semanas: continua ? null : semanas });
    setSalvando(false);
    if (ok) aoFechar();
  };

  return (
    <Dialog open onOpenChange={(aberto) => !aberto && aoFechar()}>
      <DialogContent data-e2e="dialogo-periodo">
        <DialogHeader>
          <DialogTitle>Período da campanha</DialogTitle>
          <DialogDescription>
            {campanha.continua ? "Hoje ela é contínua: renova toda semana." : `Hoje: ${atuais} ${atuais === 1 ? "semana" : "semanas"}, até ${dataBR(campanha.fim)}.`} Mudar o período não reinicia o aprendizado da Meta.
          </DialogDescription>
        </DialogHeader>
        <label className={`flex items-start justify-between gap-3 p-3 rounded-lg cursor-pointer ${continua ? "bg-amber-500/10 border border-amber-500/40" : "bg-muted"}`}>
          <span className="text-sm">
            <span className="font-medium">Campanha contínua</span>
            <span className="block text-xs text-muted-foreground mt-0.5">Renova sozinha toda semana ({reais(campanha.semanal_com_imposto_centavos)} com imposto) até você pausar ou encerrar.</span>
          </span>
          <Switch checked={continua} onCheckedChange={setContinua} data-e2e="dialogo-periodo-continua" />
        </label>
        {!continua && (
          <div>
            <p className="text-sm font-medium mb-1.5">Duração total</p>
            <div className="flex flex-wrap gap-2">
              {opcoes.map((s) => (
                <button key={s} type="button" onClick={() => setSemanas(s)} data-e2e={`dialogo-periodo-${s}`}
                  className={`rounded-lg border px-3 py-1.5 text-sm font-medium ${semanas === s ? "border-primary bg-primary/10 text-primary" : "hover:border-primary"}`}>
                  {s} {s === 1 ? "semana" : "semanas"}
                </button>
              ))}
            </div>
            {fimNovo && <p className="text-xs text-muted-foreground mt-2" data-e2e="dialogo-periodo-fim">
              Termina em <b className="text-foreground">{dataBR(fimNovo)}</b>
              {diferenca !== 0 && <> · {diferenca > 0 ? "soma" : "tira"} {reais(Math.abs(diferenca))} do total (sem o imposto)</>}.
            </p>}
          </div>
        )}
        <DialogFooter>
          <button type="button" onClick={aoFechar} className="h-10 px-4 rounded-lg border text-sm font-medium hover:bg-muted">Cancelar</button>
          <button type="button" onClick={salvar} disabled={!mudou || salvando} data-e2e="dialogo-periodo-salvar"
            className="h-10 px-5 rounded-lg bg-primary text-primary-foreground text-sm font-semibold disabled:opacity-50">
            {salvando ? "Salvando…" : "Salvar período"}
          </button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
